export default (params) => ({
  trigger: {
    name: 'product_sub_title.click_reviews_in_subtitle',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
    },
    event: {
      name: 'read_reviews',
      params: {
        sub_feature: null,
      },
    },
  },
});
